import 'babel-polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import CartMain from './templates/CartMain';
import colors from 'vuetify/es5/util/colors'
import Axios from 'axios';
import ADA from '../common/ada/ADA';
import './ada';

function reportJSError(err) {
	if (((new Date()) - reportJSError.lastErrorDate) < 10000) {
		return false;
	}
	reportJSError.lastErrorDate = new Date();
	let data = new FormData();
	data.set('url', window.location.href);
	data.set('msg', err.message ? err.message : err);
	data.set('stack', err.stack || null);
	data.set('row', err.lineNumber || 0);

	Axios({
		method: "post",
		url: "/tools/ajax/handle_js_error.php",
		data: data,
		config: {headers: {'Content-Type': 'multipart/form-data'}}
	});
}

Vue.config.errorHandler = function (err, vm, info) {
	console.error("Caught error", err);
	reportJSError(err);
};
window.onunhandledrejection = function (err) {
	console.error("Caught unhandled rejection", err.reason);
	reportJSError(err.reason ? err.reason : err);
};

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$globs = { ...window.cfg };

Vue.prototype.$const = {
};

Vue.use(Vuetify, {
	theme: {
		accent: '#2170f2',
	}
});

Vue.use(ADA);

const app = new Vue({
	el: '#sc-body',

	components: {
		'cart-main': CartMain,
	},

	data() {
		return {
			loading: false,
		};
	},

	mounted() {
		this.init();
	},

	computed: {},

	methods: {
		init() {
			let self = this;

			self.$eventHub.$on('show-loader', () => {
				self.loading = true;
			});

			self.$eventHub.$on('hide-loader', () => {
				self.loading = false;
			});
		},
	},
});
